module.exports = __webpack_public_path__ + "img/266-2.e4c89872.jpg";